import React from "react"

import { styled } from "@mui/material"

import Card from "./Card"

const Cards = (props) => {
  const {
    cards = [],
    columns,
    createLink,
    footer = true
  } = props

  const StyledCards = styled("div", {
    shouldForwardProp: (prop) => prop !== "columns",
  })(({ theme, columns }) => {
    return {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      gap: columns >= 5 ? theme.spacing(1) : "var(--size-gutter)"
    }
  })

  return (
    <StyledCards className="cards" columns={columns}>
      {cards.map((card, ix) => (
        <Card
          key={ix}
          card={card}
          columns={columns}
          createLink={createLink}
          footer={footer}
        />
      ))}
    </StyledCards>
  )
}

export default React.memo(Cards)